import React from 'react';
import PropTypes from 'prop-types';

export default function Download(props) {
  return (
    <svg width={props.width} height={props.width} viewBox="0 0 24 24" fill="none" stroke={props.color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
  );
}

Download.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
};

Download.defaultProps = {
  color: '#202020',
  width: 24,
};